<template>
  <div class="w-10/12 2xl:w-8/12 mx-auto flex-row flex-wrap justify-between font-costea">
    <h1 class="font-costea pt-3 pb-1 mb-6 mt-2 border-b-2 text-h24 font-medium text-costeaBlack">
        Mi perfil
    </h1>

    <div class="grid grid-cols-12 gap-5">
          <div class="grid col-start-1 col-end-13 lg:col-start-1 lg:col-end-4 gap-y-5 w-full">
            <div v-for="profile in user" :key="profile.id" class=" bg-white p-6 rounded-md flex flex-row lg:flex-col items-start">
              <div class="flex flex-row items-center mr-10 ">
                <img class="w-20 h-auto mr-2 rounded-md" :src="showImage(profile.picture)" alt="Foto de perfil usuario costea">
                <div class="flex h-20 flex-col justify-center pl-0 md:pl-2 font-costea">
                  <h4 class="text-costeaBlack font-medium"> {{profile.name}} {{profile.last_name ? profile.last_name : ''}}</h4>
                </div>
              </div>
              <div class="flex flex-col font-costea text-costeaGray mt-0 lg:mt-4 text-t14">
                  <div class="flex flex-row my-1 justify-start items-start">
                    <i class="ri-mail-line mr-2 text-t14"></i>
                    <p>{{profile.email}}</p>
                  </div>
                  <div v-if="profile.telephone" class="flex flex-row my-1 justify-start items-start">
                    <i class="ri-phone-line mr-2 text-t14"></i>
                    <p>{{profile.telephone}}</p>
                  </div>
                  <div class="flex flex-row my-1 justify-start items-start">
                    <i class="ri-user-follow-line mr-2 text-t14"></i>
                    <p>Administrador</p>
                  </div>
              </div>
            </div>

            <div class="bg-white pt-3 p-6 lg:p-0 lg:pb-6 flex flex-col sm:flex-row lg:flex-col justify-center items-center font-costea rounded-md">
              <img src="@/assets/img/HelpImage.svg" alt="">
              <div class="px-6">
                <h4 class="text-t14 mt-3 text-costeaBlack font-medium text-center sm:text-left lg:text-center">¿Necesitas ayuda?</h4>
                <p class="text-center sm:text-left lg:text-center mt-1 mb-3 text-t11 text-costeaGray">Si tienes problemas con la aplicación, ponte en contacto con nosotros, nos encantaría escucharte.</p>
              </div>
              <button class="bg-costeaBtn2 text-costeaPrimary px-4 py-2 text-t12 rounded-md">Escribenos</button>
            </div>
          </div>

          <div class="col-start-1 col-end-13 lg:col-start-4 lg:col-end-13 bg-white p-6 rounded-md overflow-auto">
            <div class="w-full">
              <div class="grid grid-cols-2 font-costea text-t16 relative">
                <button v-for="tab in this.tabs" :key="tab.id" @click="selected = tab.component" 
                        :class="['text-left px-4 h-auto lg:h-8 border-b-2 cursor-pointer border-costeaBtn2Hover text-costeaBtn2Hover outline-none', {active: selected == tab.component}]">
                        {{tab.txt}}
                </button>
                <!--<button class="px-2 col-start-6 col-end-13 h-8 border-b-2 cursor-pointer border-costeaBtn2 text-costeaBtn2">Cambio de contraseña</button>-->
              </div>
              <div class="w-full relative">
                <transition name="fade" mode="out-in">
                  <component :is="selected" class="h-full"/>
                </transition>
              </div>
            </div>
          </div>
    </div>
  </div>

</template>

<script>
import BasicInfo from '@/components/profile/BasicInfo.vue'
import ChangePass from '@/components/profile/ChangePass.vue'
import {mapState} from 'vuex'
import axios from 'axios'

export default {
    name : "Profile",
    data: function(){
      return{
        tabs:[
          {
            id:1,
            component: "BasicInfo",
            txt: "Información básica",
            css: "border-costeaPrimary text-costeaPrimary font-medium"
          },
          {
            id:2,
            component: "ChangePass",
            txt:"Cambio de contraseña",
            css: "border-costeaPrimary text-costeaPrimary font-medium"
          }
        ],
        selected: "BasicInfo",
        secretWord: localStorage.getItem('secret-word'),

        user: []
      }
    },
    components:{
      BasicInfo,
      ChangePass
    },
    computed:{
      ...mapState(['costea'])
    },
    methods:{
      getUsuario(){
        const config = {
          headers:{
            Authorization: 'Bearer '+localStorage.getItem('token'),
            'Content-Type': 'multipart/form-data'
          }
        }
        axios.get(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}users`, config)
        .then(response =>{
          let data = response.data; 
          this.user =  data.filter(data =>{
            return data.email === localStorage.getItem('email')
          })
        })
        .catch(error =>{
          console.log(error)
        });
      },
      showImage(imagen){
        if(imagen != null){
          return this.costea.protocol + this.secretWord + '.backend.costea.com.co/' + imagen
        }else{
          return '/img/perfilCostea.png'
        }
      },
    },
    beforeMount(){
      this.getUsuario()
    }
}
</script>

<style>
.active{
  border-color: #056cf2 !important;
  color: #056cf2 !important;
  font-weight: 500;
  outline: none !important;
}

.fade-enter-active,
.fade-leave-active{
  transition: 0.3s ease;
}
.fade-enter{
  opacity: 0;
  transform: translateY(-10%);
  overflow: hidden;
  position:absolute;
}
.fade-leave-to{
  opacity: 0;
  transform: translateY(10%);
  overflow: hidden;
  position:absolute;
}
</style>